import type { JSX } from 'react';
type InlineCodeProps = {
	text: string;
};

export function InlineCode({ text }: InlineCodeProps): JSX.Element {
	return (
		<span className="inline-code-container">
			<code>{text}</code>
		</span>
	);
}
